export default {
  SPECIAL_URL: "https://static.smartstake.io/special/",
  app: {
    title: "Oasis Analytics",
    appSymbol: "OASIS",
    appName: "Oasis",
    defaultValidatorViewStatus: "Elected",
    VALIDATORS_KEY: "VALIDATORS_LIST_V2",
    defaultLogo: "/images/default.jpg",
  },
  urls: {
    stakingHomeForValidator: ""
  },
  colors: {
    text: "white",
    chartColor1: "darkgray",
    chartColor2: "lightblue",
    chartColor3: "lightgreen",
    chartColor4: "#faa84b",
    chartColor5: "yellow",
    chartColor6: "purple",
    chartColor7: "green",
    chartColor8: "blue",
    chartColor9: "lightgray",
    chartColorBright: "red",

    "--color-text": "white",
    "--color-text-gray": "#6d738c",
    "--color-background": "#212024",
    "--color-smart-primary": "#faa84c",
    "--color-smart-primary-bright": "#ffc107",
    "--color-smart-main-surface": "#0f1011",
    "--color-smart-main-surface--accent": "#1b191b",
    "--color-custom-surface": "#17141a",
  },
  menuStyle:
    {borderRadius: '3px',  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    background: 'rgba(255, 255, 255, 1)', padding: '2px 0',
    fontSize: '90%', position: 'fixed',
    overflow: 'auto', maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
    zIndex: '998'}

};



// WEBPACK FOOTER //
// ./src/constants.js